import { render, staticRenderFns } from "./chart_status_grp.vue?vue&type=template&id=545a12ea"
import script from "./chart_status_grp.vue?vue&type=script&lang=js"
export * from "./chart_status_grp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports